import {serviceData} from "@/constants";

/**
 * @returns {object|null}
 */
export const getToken = () => {
    const storeData = window.localStorage.getItem(serviceData.TOKEN_KEY);
    return storeData !== null ? JSON.parse(storeData) : null;
};

/**
 * @param {object} data
 */
export const saveToken = (data) => {
    window.localStorage.setItem(serviceData.TOKEN_KEY, JSON.stringify(data));
};

export const destroyToken = () => {
    window.localStorage.removeItem(serviceData.TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken };
